import styled from '@emotion/styled'

export const UpsellGuardWrapper = styled.div`
  display: inline-block;
  width: 100%;
  position: relative;
`
